export default __webpack_public_path__ + "static/media/photo--sm--kara14.5fbfaecf.jpg";